import { getCookie } from 'cookies-next/client';
import {
  IS_WORKOS_API_E2E_TESTS_COOKIE,
  REVIEW_APP_NAME_FROM_API_E2E_TESTS_COOKIE,
} from '@/_constants/cookies';

const apiUrl = () => {
  if (process.env.VITEST) {
    return 'http://localhost:3000';
  }

  const e2eBranchName =
    getCookie(REVIEW_APP_NAME_FROM_API_E2E_TESTS_COOKIE) ||
    process.env.REVIEW_APP_NAME_FROM_API_E2E_TESTS;

  if (e2eBranchName?.includes('soraban-pr-')) {
    return `https://${e2eBranchName}.herokuapp.com`;
  }

  if (process.env.NEXT_PUBLIC_API_URL?.includes('release-api')) {
    const branchName = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_REF;
    const isReviewApp = branchName && branchName.includes('soraban-pr-');
    const reviewAppNumber = isReviewApp && branchName.split('soraban-pr-')[1];
    const reviewAppName = `soraban-pr-${reviewAppNumber}`;
    const reviewAppUrl =
      branchName &&
      branchName.endsWith(reviewAppName) &&
      `https://${reviewAppName}.herokuapp.com`;

    if (reviewAppUrl) return reviewAppUrl;

    if (getCookie(IS_WORKOS_API_E2E_TESTS_COOKIE)) {
      return 'https://release-api.soraban.com';
    }

    return 'https://api.soraban.com';
  }

  if (process.env.NEXT_PUBLIC_API_URL) {
    return process.env.NEXT_PUBLIC_API_URL;
  }

  return 'http://localhost:3000';
};

const API_URL = apiUrl();
const AGENT_API_URL =
  process.env.NEXT_PUBLIC_API_AGENT_URL ||
  'https://soraban-admin-assistant-848234929764.us-central1.run.app';

export { API_URL, AGENT_API_URL };
